
import { classNames } from '../common/utils/utils';

interface CardHeaderProps {
  children: React.ReactNode;
  isOneElement?: boolean;
}

const CardHeader = ({ children, isOneElement }: CardHeaderProps) => (
  <div
    className={classNames(
      isOneElement ? 'flex-row-reverse' : 'flex-row',
      'min-h-[70px] w-full sm:px-8 px-4 py-4 flex items-center justify-between',
    )}
  >
    {children}
  </div>
);

export default CardHeader;
